import { Environment } from './environment.model';

export const environment: Environment = {
    production: false,
    API_URL: 'https://api.arap.qa.ap.alight.com',
    redirectURL: 'https://arap.qa.ap.alight.com',
    externalCognitoTokenURL: "https://arap-qa-ext.auth.us-east-1.amazoncognito.com/oauth2/token",
    internalCognitoTokenURL: "https://arap-qa-int.auth.us-east-1.amazoncognito.com/oauth2/token",
    internalCognitoAuthorizeURL: "https://arap-qa-int.auth.us-east-1.amazoncognito.com/oauth2/authorize",
    sso_external_client_id: '1vaukv89titko3mng8cu84aq67',
    sso_internal_client_id: '3vg7roofe258moabua674jdds8',
    sso_api_pwd: '',
    identityPoolId: "us-east-1:0c3ebb2a-67e6-46e1-a772-f95fe76d6ae3",
    showAIButton: true,
    chatEnabled: true,
    chatClientCodes: [],
    chatAllowedUserIdSubstrings: [],
    endpoint: "https://dataplane.rum.us-east-1.amazonaws.com",
    rumApplicationId: 'ba9ae002-ef60-480b-870d-386bde58e945',
    websocketUrl: 'wss://wss.arap.qa.ap.alight.com',
    useApiMock: false,
    quicksightEmbedBaseUrl: "https://us-east-1.quicksight.aws.amazon.com/embed/",
    brandingApiUrl: 'https://api.ap.alight.com/api/channel/foundationwidgets/worklifebranding/public',
};
